import React from 'react';

// icons
import { FaClock, FaCheck, FaTimes, FaExclamationTriangle, FaUser, FaWalking } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import { CustomSpinner } from '_components/atoms';

/**
 * PassengerStatusBadge Component
 *
 * Displays passenger status as a colored badge with icon and text.
 * Parses the status string to determine appropriate styling and icon.
 */
const PassengerStatusBadge = ({ status, size = 'sm', showUnrejectBtn = false, unRejectType = null, unRejectAction = null, unRejectPaxStatus = false }) => {
    // Parse status and determine styling
    const getStatusConfig = (status) => {
        const statusLower = status?.toLowerCase() || '';

        // Grey for unassigned/unplanned
        if (statusLower.includes('not presented') ||
            statusLower.includes('unplanned') ||
            statusLower.includes('unassigned')) {
            return {
                bgColor: '#f3f4f6',
                textColor: '#374151',
                icon: <FaClock />,
                iconColor: '#6b7280'
            };
        }

        // Red for no shows/assistance issues
        if (statusLower.includes('no show') ||
            statusLower.includes('rejected') ||
            statusLower.includes('no boarding assist') ||
            statusLower.includes('not required')) {
            return {
                bgColor: '#fef2f2',
                textColor: '#991b1b',
                icon: <FaTimes />,
                iconColor: '#dc2626'
            };
        }

        // Green for completed
        if (statusLower.includes('completed') ||
            statusLower.includes('checked-in') ||
            statusLower.includes('boarded')) {
            return {
                bgColor: '#f0fdf4',
                textColor: '#166534',
                icon: <FaCheck />,
                iconColor: '#16a34a'
            };
        }

        // Orange for in progress/active
        if (statusLower.includes('active') ||
            statusLower.includes('collected') ||
            statusLower.includes('selected')) {
            return {
                bgColor: '#fff7ed',
                textColor: '#9a3412',
                icon: <FaWalking />,
                iconColor: '#ea580c'
            };
        }

        // Blue for waiting/pending/allocated/at location
        if (statusLower.includes('waiting') ||
            statusLower.includes('confirmed') ||
            statusLower.includes('allocated') ||
            statusLower.includes('at location') ||
            statusLower.includes('agent at location')) {
            return {
                bgColor: '#eff6ff',
                textColor: '#1e40af',
                icon: <FaUser />,
                iconColor: '#3b82f6'
            };
        }

        // Default grey
        return {
            bgColor: '#f9fafb',
            textColor: '#6b7280',
            icon: <FaClock />,
            iconColor: '#9ca3af'
        };
    };

    const config = getStatusConfig(status);

    // Size configurations
    const sizeConfig = {
        sm: {
            padding: '4px 8px',
            fontSize: '12px',
            iconSize: '12px',
            borderRadius: '4px'
        },
        md: {
            padding: '6px 12px',
            fontSize: '14px',
            iconSize: '14px',
            borderRadius: '6px'
        }
    };

    const currentSize = sizeConfig[size] || sizeConfig.sm;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: currentSize.padding,
                    backgroundColor: config.bgColor,
                    color: config.textColor,
                    borderRadius: currentSize.borderRadius,
                    fontSize: currentSize.fontSize,
                    fontWeight: '500',
                    // whiteSpace: 'nowrap'
                }}
            >
                <span
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: currentSize.iconSize,
                        color: config.iconColor
                    }}
                >
                    {config.icon}
                </span>
                <span style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>{status || 'Unknown'}</span>

            </div>
            {showUnrejectBtn && (
                <Button variant='outline-primary' size='sm' onClick={unRejectAction}>
                    {unRejectPaxStatus ? <CustomSpinner size='small' /> : "Un Reject"}
                </Button>
            )}
        </div>
    );
};

export default PassengerStatusBadge;